import { IconButton, Tooltip, Box, Typography } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { generateButtonSx } from "../../../utils/elementor-style-override";
import { CategoryChip, StatusChip } from "../utils/CategoryStatusChips";

export const getAgentColumns = (onViewDetails) => [
	{
		field: "ticketId",
		headerName: "Ticket ID",
		width: 120,
		renderCell: (params) => (
			<Box sx={{ alignItems: "center", display: "flex", height: "100%" }}>
				<Typography variant="body2" sx={{ fontWeight: 700, color: "#1D54A2" }}>
					{params.value}
				</Typography>
			</Box>
		),
	},
	{
		field: "subject",
		headerName: "Subject",
		flex: 1,
		minWidth: 200,
		renderCell: (params) => (
			<Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", height: "100%" }}>
				<Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1.3 }}>
					{params.value}
				</Typography>
			</Box>
		),
	},
	{
		field: "category",
		headerName: "Category",
		width: 160,
		renderCell: (params) => (
			<Box sx={{ alignItems: "center", display: "flex", height: "100%" }}>
				<CategoryChip value={params.value} />
			</Box>
		),
	},
	{
		field: "dateSubmitted",
		headerName: "Date Submitted",
		width: 180,
		renderCell: (params) => (
			<Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", height: "100%" }}>
				<Typography variant="body2">{params.value}</Typography>
			</Box>
		),
	},
	{
		field: "status",
		headerName: "Status",
		width: 150,
		renderCell: (params) => (
			<Box sx={{ alignItems: "center", display: "flex", height: "100%" }}>
				<StatusChip value={params.value} />{" "}
			</Box>
		),
	},
	{
		field: "actions",
		headerName: "Details",
		width: 100,
		sortable: false,
		filterable: false,
		headerAlign: "center",
		renderCell: (params) => (
			<Box sx={{ alignItems: "center", display: "flex", height: "100%", justifyContent: "center" }}>
				<Tooltip title="View Ticket Details">
					<IconButton
						size="small"
						onClick={() => onViewDetails(params.row)}
						sx={{
							color: "#1D54A2",
							bgcolor: "#E8F0FA !important",
							...generateButtonSx({ bg: "#F4F4F5 !important", text: "#1D54A2" }, { bg: "#F4F4F5 !important", text: "#1D54A2" }),
						}}
					>
						<VisibilityIcon sx={{ fontSize: 20 }} />
					</IconButton>
				</Tooltip>
			</Box>
		),
	},
];
